import React from "react";

const IGIcon = () => {
	return (
		<svg
			width='36'
			height='37'
			viewBox='0 0 36 37'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'>
			<g clipPath='url(#clip0_42_58)'>
				<path
					d='M17.9983 36.2256C27.8 36.2256 35.7459 28.2798 35.7459 18.478C35.7459 8.67633 27.8 0.730469 17.9983 0.730469C8.19659 0.730469 0.250732 8.67633 0.250732 18.478C0.250732 28.2798 8.19659 36.2256 17.9983 36.2256Z'
					fill='url(#paint0_linear_42_58)'
				/>
				<path
					d='M24.2809 13.6755C25.0424 13.6755 25.6597 13.0582 25.6597 12.2967C25.6597 11.5353 25.0424 10.918 24.2809 10.918C23.5194 10.918 22.9022 11.5353 22.9022 12.2967C22.9022 13.0582 23.5194 13.6755 24.2809 13.6755Z'
					fill='white'
				/>
				<path
					d='M18.1513 12.686C14.9578 12.686 12.3595 15.2842 12.3595 18.4777C12.3595 21.6713 14.9578 24.2695 18.1513 24.2695C21.3448 24.2695 23.9429 21.6713 23.9429 18.4777C23.9429 15.2842 21.3448 12.686 18.1513 12.686ZM18.1513 22.1877C16.1056 22.1877 14.4412 20.5235 14.4412 18.4777C14.4412 16.432 16.1056 14.7678 18.1513 14.7678C20.197 14.7678 21.8612 16.432 21.8612 18.4777C21.8612 20.5235 20.197 22.1877 18.1513 22.1877Z'
					fill='white'
				/>
				<path
					d='M22.7492 30.2368H13.3599C9.46467 30.2368 6.29584 27.068 6.29584 23.1728V13.783C6.29584 9.88778 9.46467 6.71899 13.3599 6.71899H22.7492C26.6444 6.71899 29.8136 9.88778 29.8136 13.783V23.1728C29.8136 27.0679 26.6444 30.2368 22.7492 30.2368ZM13.3599 8.9315C10.6846 8.9315 8.50834 11.1077 8.50834 13.783V23.1728C8.50834 25.8481 10.6846 28.0243 13.3599 28.0243H22.7492C25.4245 28.0243 27.6011 25.8481 27.6011 23.1728V13.783C27.6011 11.1077 25.4245 8.9315 22.7492 8.9315H13.3599Z'
					fill='white'
				/>
			</g>
			<defs>
				<linearGradient
					id='paint0_linear_42_58'
					x1='2.86443'
					y1='33.6119'
					x2='41.2187'
					y2='-4.74237'
					gradientUnits='userSpaceOnUse'>
					<stop offset='0.0011' stopColor='#FBE18A' />
					<stop offset='0.2094' stopColor='#FCBB45' />
					<stop offset='0.3765' stopColor='#F75274' />
					<stop offset='0.5238' stopColor='#D53692' />
					<stop offset='0.7394' stopColor='#8F39CE' />
					<stop offset='1' stopColor='#5B4FE9' />
				</linearGradient>
				<clipPath id='clip0_42_58'>
					<rect
						width='36'
						height='36'
						fill='white'
						transform='translate(0 0.5)'
					/>
				</clipPath>
			</defs>
		</svg>
	);
};

export default IGIcon;
